import React, { useEffect, useRef } from 'react';

// Custom component to render MathJax content
const MathJaxRenderer = ({ content }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Ensure MathJax is loaded
    if (!window.MathJax) {
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.9/MathJax.js?config=TeX-MML-AM_CHTML';
      script.async = true;
      
      script.onload = () => {
        window.MathJax.Hub.Config({
          tex2jax: {
            inlineMath: [['$', '$'], ['\\(', '\\)']],
            displayMath: [['$$', '$$'], ['\\[', '\\]']],
            processEscapes: true
          },
          showMathMenu: false,
          "HTML-CSS": { 
            availableFonts: ["TeX"],
            scale: 100,
            linebreaks: { automatic: true }
          }
        });
        
        // Typeset the content
        if (containerRef.current) {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, containerRef.current]);
        }
      };
      
      document.head.appendChild(script);
    } else {
      // If MathJax is already loaded, just typeset the content
      if (containerRef.current) {
        window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, containerRef.current]);
      }
    }
  }, [content]);

  return (
    <div ref={containerRef} dangerouslySetInnerHTML={{ __html: content }} />
  );
};

export default MathJaxRenderer;